
const rowsPerPage = [5,10,50,100,-1];//$vuetify.dataIterator.rowsPerPageAll
export default rowsPerPage;